<template>
    <div>
        <p>Closed</p>

    </div>

</template>

<script>
export default {
    name: 'ClosedPools',
    props: ['pool_type']

}
</script>

<style>

</style>